import { HiOutlineTrash } from 'react-icons/hi'

import { Button } from '@/components/ui'

interface RemoveButtonIProps {
  isDisabled?: boolean
  onRemove: () => void
}

export const RemoveButton = ({ isDisabled, onRemove }: RemoveButtonIProps) => {
  return (
    <Button
      _hover={{ bgColor: 'incident.active.200' }}
      boxShadow='0 2px 7px 0 rgba(189,25,25,0.5)'
      isDisabled={isDisabled}
      // Stop middle-clicks reaching the row, which would open the rule.
      onAuxClick={(e: React.MouseEvent) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation()
        onRemove()
      }}
      px='5px'
      py='2px'
      size='xs'
      variant='danger'
    >
      <HiOutlineTrash color='white' size='20px' />
    </Button>
  )
}
